import { useState } from "react";

// validator 사용
export const useInput = (initialValue, validator) => {
  const [value, setValue] = useState(initialValue);

  // 변경
  const onChange = (event) => {
    const text = event.target.value;
    let willUpdate = true;
    if (typeof validator === "function") {
      willUpdate = validator(text);
    }
    if (willUpdate) {
      setValue(text);
    }
  };
  // 변경
  const onChangeVal = (val) => {
    setValue(val);
  };
  // 초기화
  const onReset = (defaultData = "") => {
    setValue(defaultData);
  };
  return { value, onChange, onChangeVal, onReset };
};

// validator 사용
export const useInputNoVal = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  // 변경
  const onChange = (event) => {
    const text = event.target.value;
    setValue(text);
  };
  // 초기화
  const onReset = (defaultData = "") => {
    setValue(defaultData);
  };
  return { value, onChange, onReset };
};

// validator 사용
export const useBackdrop = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  // 변경
  const onChange = (val = value) => {
    // const text = event.target.value;
    setValue(!val);
  };

  return { value, onChange };
};
